var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0786 43.4582C36.2723 43.4582 46.1572 34.1774 46.1572 22.7291C46.1572 11.2807 36.2723 2 24.0786 2C11.8849 2 2 11.2807 2 22.7291C2 34.1774 11.8849 43.4582 24.0786 43.4582Z",
    fill: "",
    stroke: "#1A1A1A",
    strokeWidth: 2.24214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.462 32.4203L27.9179 23.4596C27.7751 23.3237 27.612 23.2081 27.4337 23.1164C28.6854 21.2874 29.1773 19.0903 28.8159 16.943C28.4544 14.7957 27.2648 12.8481 25.4734 11.4708C23.6819 10.0934 21.4137 9.38237 19.1003 9.47301C16.7868 9.56365 14.5895 10.4496 12.9266 11.9623C11.2636 13.475 10.2509 15.5089 10.0813 17.677C9.91164 19.8451 10.5968 21.9962 12.0065 23.7208C13.4161 25.4454 15.4519 26.6234 17.7264 27.0305C20.0009 27.4376 22.3555 27.0454 24.3421 25.9286C24.4476 26.1172 24.5827 26.2897 24.743 26.4405L34.2869 35.4012C34.4954 35.5969 34.7429 35.7522 35.0153 35.8581C35.2877 35.964 35.5796 36.0186 35.8745 36.0186C36.1693 36.0186 36.4612 35.9641 36.7336 35.8582C37.006 35.7522 37.2535 35.597 37.462 35.4012C37.6705 35.2055 37.8358 34.9731 37.9487 34.7174C38.0615 34.4617 38.1196 34.1876 38.1196 33.9108C38.1196 33.634 38.0615 33.3599 37.9487 33.1041C37.8358 32.8484 37.6705 32.616 37.462 32.4203ZM25.4324 23.017C24.2548 24.3278 22.6231 25.2073 20.8237 25.5012C19.0243 25.7951 17.1721 25.4847 15.5922 24.6243C14.0122 23.764 12.8055 22.4087 12.1838 20.7963C11.562 19.1839 11.5649 17.4175 12.1919 15.8069C12.819 14.1963 14.0302 12.8446 15.613 11.9888C17.1957 11.133 19.049 10.828 20.8474 11.1271C22.6458 11.4263 24.2746 12.3105 25.4479 13.6247C26.6212 14.9389 27.264 16.599 27.2636 18.3138C27.2655 20.0357 26.6166 21.7022 25.4324 23.017Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.44ec086d58f9b638cf5bdf97fa070444.svg";
export { ForwardRef as ReactComponent };